/* cf-calc-mobile-keyboard.js - Click Fencing, 2026-09-10
 *
 * Pete, on a real Samsung after reviewing preview 141618806878:
 *   "the main issue is when I go to type the keyboard comes up, blocks half the
 *    screen and the drawing disappears from the top"
 *   "next button hard to find. also some scrolling clipping going on"
 *
 * Three things, all measured on an emulated iPhone 14 Pro against the preview.
 *
 * 1. THE DRAWING SCROLLS AWAY WHILE TYPING.
 *    #section-preview computes position:relative, so it scrolls with the page.
 *    cf-preview-mobile-band.js IS loaded (__cfPreviewMobileBandPatched is set) but
 *    the element was still relative at the moment of measurement, so nothing was
 *    holding it. With a keyboard up there is only ~360px of screen and the drawing
 *    is off the top of it - the customer is typing a length with no picture of what
 *    it does. This pins the drawing to the top of the visual viewport WHILE a field
 *    is focused, and puts it back exactly as it was on blur.
 *
 * 2. THE STICKY CTA BAR MADE IT WORSE - MY FAULT.
 *    Measured with the viewport shrunk to 360px to stand in for the keyboard, the
 *    bar from cf-calc-mobile-cta.js sat at top 291 with height 69: it was eating
 *    69px of the ~360px the customer had left. It is now hidden whenever a field is
 *    focused, and comes back on blur.
 *
 * 3. THE SECTION TAB ROW IS CLIPPED.
 *    .section-tabs measures 363px wide against a 492px scrollWidth with
 *    overflow-x:visible - 129px of it, including the red Delete button, is off the
 *    right edge and unreachable. That is Pete's "scrolling clipping". This is
 *    wide-BY-ACCIDENT (a row of buttons), so per cf-mobile.liquid trap 1 the fix is
 *    to let it REFLOW - flex-wrap - not to cap or scroll it. The fence drawing is
 *    the wide-by-nature case and is deliberately left alone.
 *
 * Display only. No price, variant, quantity, cart line or solver is touched.
 * Every entry point is try/caught; on any error the page is left as the theme
 * rendered it.
 */
(function () {
  'use strict';
  if (window.__cfCalcMobileKeyboard) return;
  window.__cfCalcMobileKeyboard = true;

  var TAG = '[cf-calc-mobile-keyboard]';
  var PAGES = /\/pages\/(glass-fencing|fence-calculator|blade-fence-calculator|flat-top-fence-calculator|perfmesh-fence|base-mount-batten-calculator)/;
  if (!PAGES.test(location.pathname)) return;

  var MQ = window.matchMedia('(max-width: 749px)');

  function css() {
    if (document.getElementById('cf-cmk-css')) return;
    var s = document.createElement('style');
    s.id = 'cf-cmk-css';
    s.textContent = [
      '@media (max-width: 749px){',
      /* 3. the button row reflows instead of running off the edge */
      /* .section-tabs holds ONE unclassed child that is itself the flex row, so
         wrapping only the outer box moved nothing - measured 476px child inside a
         363px container. Both have to wrap. */
      '  body .calculator-page .section-tabs,',
      '  body .calculator-page .section-tabs > div{display:flex!important;flex-wrap:wrap!important;',
      '    gap:8px!important;min-width:0!important;overflow-x:visible!important;max-width:100%!important}',
      '  body .calculator-page .section-tabs *{min-width:0!important}',
      '  body .calculator-page .section-tabs button,',
      '  body .calculator-page .section-tabs > div > *{flex:0 1 auto!important}',
      /* 1. the drawing pinned while a field is focused */
      '  body.cf-cmk-typing .cf-cmk-pinned{position:fixed!important;top:0!important;left:0!important;',
      '    right:0!important;width:auto!important;margin:0!important;z-index:2147481500!important;',
      '    background:#fff!important;box-shadow:0 3px 12px rgba(12,43,66,.16)!important;',
      '    border-bottom:1px solid #d9e2ea!important}',
      /* 2. the CTA bar stands down while the keyboard is up */
      '  body.cf-cmk-typing #cf-cmc-bar{transform:translateY(110%)!important}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  var pinned = null, placeholder = null;

  function isTextField(el) {
    if (!el) return false;
    var t = (el.tagName || '').toUpperCase();
    if (t === 'TEXTAREA') return true;
    if (t !== 'INPUT') return false;
    var ty = (el.type || 'text').toLowerCase();
    return ['text', 'number', 'tel', 'email', 'search'].indexOf(ty) >= 0;
  }

  /* Only pin a drawing that actually has something drawn in it. Pinning an empty
     placeholder box would cover the screen for no benefit. */
  function drawnPreview() {
    var el = document.querySelector('#section-preview');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (r.height < 40) return null;
    if (!/\d/.test(el.innerText || '')) return null;
    return el;
  }

  function pin() {
    try {
      if (!MQ.matches || pinned) return;
      var el = drawnPreview();
      if (!el) return;
      var h = Math.round(el.getBoundingClientRect().height);
      placeholder = document.createElement('div');
      placeholder.style.height = h + 'px';
      placeholder.setAttribute('data-cf-cmk-ph', '1');
      el.parentNode.insertBefore(placeholder, el);
      el.classList.add('cf-cmk-pinned');
      document.body.classList.add('cf-cmk-typing');
      pinned = el;
    } catch (e) { console.warn(TAG, 'pin', e); }
  }

  function unpin() {
    try {
      document.body.classList.remove('cf-cmk-typing');
      if (pinned) { pinned.classList.remove('cf-cmk-pinned'); pinned = null; }
      if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
      placeholder = null;
    } catch (e) { console.warn(TAG, 'unpin', e); }
  }

  function start() {
    try {
      css();
      document.addEventListener('focusin', function (ev) {
        if (!MQ.matches) return;
        if (!isTextField(ev.target)) return;
        if (!ev.target.closest('.calculator-page')) return;
        pin();
      }, true);

      document.addEventListener('focusout', function (ev) {
        if (!isTextField(ev.target)) return;
        /* settle first - moving between two fields should not flash the drawing */
        setTimeout(function () {
          var a = document.activeElement;
          if (isTextField(a) && a.closest && a.closest('.calculator-page')) return;
          unpin();
        }, 120);
      }, true);

      /* A rotation or a keyboard dismissal that does not fire blur still needs to
         put the page back. */
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', function () {
          if (!pinned) return;
          var a = document.activeElement;
          if (!isTextField(a)) unpin();
        });
      }
      if (MQ.addEventListener) MQ.addEventListener('change', function () { if (!MQ.matches) unpin(); });

      console.log(TAG, 'installed');
    } catch (e) { console.warn(TAG, 'start', e); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
